module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0017.289e3701.jpg";